<template>
    <v-dialog v-model="ui.display" persistent>
        <v-card v-if="data!=null">
                <v-toolbar dense color="primary" dark align="center">
                    <v-row>                        
                        <v-col cols="5" align="left">
                            <v-toolbar-title>Diagnostica variabili (anteprima)</v-toolbar-title>
                        </v-col>
                        <v-col cols="2">
                            <v-btn small light @click="save">
                                <v-icon color="success">mdi-check</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="5" align="right">
                            <v-btn small light @click="close">
                                <v-icon color="error">mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-toolbar>
                <v-container>
                    <v-expansion-panels>
                        <v-expansion-panel v-for="(variable, i) in data" :key="i">
                            <v-expansion-panel-header>
                                <v-row no-gutters>
                                    <v-col cols="6" align="left">
                                        {{ findVariable(variable._uid)._name }}
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-data-table hide-default-footer disable-pagination :headers="headers" :items="variable.results" v-if="variable.status==true">
                                    <template v-slot:item="{item}">
                                        <tr>
                                            <template v-for="(column, j, j2) in headers" >
                                                <td :key="j" v-if="column.value!='_value'&&column.value!='_detail'&&column.value!='_select'">
                                                    <span v-if="column?.type=='enum'">{{ getEnumLabel(item.register_info[column.value], column.items)}}</span>
                                                    <span v-else>{{ item.register_info?.[column.value] }}</span>
                                                </td>
                                                <td :key="j2" v-else>
                                                    <v-radio-group  v-model="variable.selected" v-if="column.value=='_select'" >
                                                        <v-radio :value="variable.results.indexOf(item)"/>
                                                    </v-radio-group>                                                    
                                                    <span v-else>{{item?.[column.value.replace('_','')]}}</span>
                                                </td>
                                            </template>                                             
                                        </tr>
                                    </template>
                                </v-data-table>
                                <v-card-text v-else>{{variable.detail}}</v-card-text>
                            </v-expansion-panel-content>
                        </v-expansion-panel> 
                    </v-expansion-panels>
                </v-container>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'DialogTestValori',
    props : {
        gateway_id : Number,
        machine_id: Number,
        interface_id : Number,
        module_schema : Object
    },
    data(){
        return{
            NETWORK : this.$store.state.Network,
            data : null,
            headers : null,
            ui : {
                display : false
            },
            variables : null
        }
    },
    methods : {
        close(){
            this.ui.display = false;
            this.data = null;
            this.variables = null;
        },
        findVariable(uid){
            for(let i=0; i<this.variables.length; i++){
                if(this.variables[i]._uid == uid){ return this.variables[i]; }
            }
        },
        getEnumLabel(value, items){
            const Num = function(value){
                if(value == null){ return false; }
                return Number(value);
            }
            for(let i=0; i<items.length; i++){
                if(Num(items[i].value) == Num(value)){ return items[i].text; }
            }
        },
        open(register){
            console.log(register);
            const variables = register.variables;
            const length = variables.length;

            const headers = new Array();
            headers.push({text:'Seleziona', value:'_select'});
            for(let i=0; i < this.module_schema.register_fields.length; i++){
                const field = this.module_schema.register_fields[i];
                headers.push({text:field.name, value:field.field, items:field.values, type:field.type});
            }
            for(let i=0; i < this.module_schema.variable_fields.length; i++){
                const field = this.module_schema.variable_fields[i];
                headers.push({text:field.name, value:field.field, items:field.values, type:field.type});
            }
            headers.push({text:'Valore calcolato', value:'_value'});
            headers.push({text:'Dettagli', value:'_detail'});
            this.headers = headers;

            const result = new Array();
            for(let i=0; i<length; i++){
                const variable = variables[i];
                const item = Object.assign({}, register, variable);
                delete item.variables;
                delete item.alarms;
                result.push(item);
            }

            const that = this;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                showdialog: false,
                body: {
                    action: 'machineregisterstest',
                    token: localStorage.user_token,
                    id_dispositivo: this.gateway_id,
                    module: {
                        interface_id : this.interface_id,
                        machine_id : this.machine_id,
                        registers : result
                    },
                },
                method: 'PUT',
                on: {
                    load: function (response) {
                        that.data = JSON.parse(response);
                        var success = true;
                        console.log(that.data);
                        that.data.forEach(e => {
                            if(e.status == false)
                                success = false;
                        });
                        register.tested = success;
                        that.ui.display = true;
                    },
                    error: function (err) {
                        alert(err.target.responseText);
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
            this.variables = variables;
        },
        save(){
            const length = this.data.length;
            const result = new Array();
            for(let i=0; i<length; i++){
                const variable = this.data[i];
                const src_variable = this.findVariable(variable._uid);
                if(variable.selected == undefined){
                    alert('Nessuna selezione per la variabile ' + src_variable._name);
                    return;
                }else{
                    result.push({
                        _uid : variable._uid,
                        data : variable.results[Number(variable.selected)].register_info
                    });
                }
            }
            this.$emit('selection', result);
            this.close();
        }
    }
}
</script>